import { Mail } from "lucide-react";
import Link from "next/link";
import React, { type HTMLAttributes, type ReactElement } from "react";
import type { Person } from "@/types";

interface PersonListItemProps extends HTMLAttributes<HTMLDivElement> {
  person: Person;
}

function PersonListItem({
  person,
}: Readonly<PersonListItemProps>): ReactElement {
  return (
    <div className="flex flex-row gap-1 items-center">
      <span className="inline-flex w-10 h-10 justify-center items-center rounded-full bg-blue-100 text-blue-700 border border-blue-500 mr-4">
        {person.firstName.charAt(0)}
        {person.lastName.charAt(0)}
      </span>
      <div className="flex flex-col gap-0">
        <h4 className="font-semibold p-0 m-0 leading-none">
          {person.firstName} {person.lastName}
        </h4>
        {person.organization ? (
          <p className="text-xs p-0 m-0">{person.organization.name}</p>
        ) : null}
      </div>
      <Link
        className="ml-auto p-2 rounded-full hover:bg-foreground hover:text-background"
        color="dark"
        href={`mailto:${person.email}`}
      >
        <Mail size={20} />
      </Link>
    </div>
  );
}

export { PersonListItem, type PersonListItemProps };
